module.exports = __webpack_public_path__ + "img/gbLogo.76ee1a5b.svg";